<template>
  <div>
    <div v-if="isList">
      <b-button size="sm" @click="showTemplate()">New Template</b-button>
      <b-table
        striped
        hover
        :items="report_templates"
        :fields="fields"
        small
        ref="selectableTable"
        id="report-template"
      >
        <template>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        <template #cell(id)="row">
          <b-button
            @click="showTemplate(row.item.id)"
            class="me-2"
            variant="pink-button"
          >
            <img src="@/assets/images/icon/view.svg" />
          </b-button>
        </template>
      </b-table>
    </div>
    <b-card v-show="!isList">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group
            id="input-group-name"
            label="Name:"
            label-for="input-name"
          >
            <b-form-select
              id="input-name"
              v-model="formData.name"
              :options="valid_templates"
              required
            ></b-form-select> </b-form-group
        ></b-col>
        <b-col cols="12" md="6">
          <b-form-group
            id="input-group-descr"
            label="Description:"
            label-for="input-description"
          >
            <b-form-input
              id="input-description"
              v-model="formData.description"
              placeholder="Enter Description"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            id="input-group-recipe"
            label="Recipe:"
            label-for="input-recipe"
          >
            <b-form-select
              id="input-recipe"
              v-model="formData.recipe"
              :options="recipes"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            id="input-group-engine"
            label="Engine:"
            label-for="input-engine"
          >
            <b-form-select
              id="input-engine"
              v-model="formData.engine"
              :options="engines"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-embed
            ref="grapejsRef"
            type="iframe"
            aspect="21by9"
            width="100%"
            height="100%"
            src="https://reporteditor.activitymanagementsolution.com/"
            allowfullscreen
          ></b-embed
        ></b-col>
        <b-col cols="12">
          <b-button @click="saveTemplate">
            Save
          </b-button>
          <b-button @click="triggerCmd('getHtml')">
            Sync
          </b-button>
          <b-button @click="isList = true">
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      formData: {
        id: "",
        name: "",
        description: "",
        recipe: "",
        engine: "handlebars",
        template: "",
      },
      fields: [
        {
          key: "id",
          label: "",
        },
        "name",
        "description",
        "recipe",
        "engine",
      ],
      isList: true,
      valid_templates: [
        { value: null, text: "Please select an option" },
        { value: "custom_invoice", text: "Invoice" },
        { value: "custom_statment", text: "Statement" },
        { value: "conquerer", text: "conquerer" },
        { value: "apple", text: "Apple" },
      ],
      recipes: [
        { value: null, text: "Please select the Recipe" },
        { value: "chrome-pdf", text: "PDF" },
        { value: "html-to-xlsx", text: "Spreadsheet" },
      ],
      engines: [{ value: "handlebars", text: "Handlebars" }],
    };
  },

  computed: {
    ...mapState("reportTemplates", [
      "report_template",
      "report_templates",
      "keys",
    ]),
  },

  watch: {},

  created() {
    window.addEventListener(
      "message",
      (event) => {
        console.log("from grapejs:", event);
        if (event.data?.cmd == "setHtml") {
          console.log("from grapejs", "In Business");
          this.formData.template = event.data?.html;
        }
      },
      false
    );
    Promise.all([
      this.$store.dispatch("reportTemplates/fetchAll"),
      this.$store.dispatch("reportTemplates/fetchOrderKeys"),
    ]).then();
  },

  mounted() {},
  methods: {
    async showTemplate(id) {
      if (id) {
        const { keys } = this;
        console.log("keys:", keys);
        await this.$store.dispatch("reportTemplates/fetchById", id);
        const iframe = this.$refs.grapejsRef.querySelectorAll("iframe")[0]
          .contentWindow;
        this.$nextTick(() => {
          Object.assign(this.formData, this.report_template);
          console.log("iframe:", iframe);
          const html = this.formData.template;
          iframe.postMessage({ cmd: "setHtml", html, keys }, "*");
        });
      } else {
        this.formData.id = null;
        this.formData.name = "";
        this.formData.description = "";
        this.formData.recipe = "";
        this.formData.engine = "";
        this.formData.template = "";
      }
      this.isList = false;
    },

    async saveTemplate() {
      console.log("Sabve temolatre", this.formData);
      if (this.formData.id) {
        await this.$store.dispatch("reportTemplates/update", {
          ...this.formData,
        });
      } else {
        await this.$store.dispatch("reportTemplates/create", {
          ...this.formData,
        });
      }
      this.$store.dispatch("reportTemplates/fetchAll");
    },

    triggerCmd(cmd, data) {
      //console.log("sending message:", this.$refs.grapejsRef);
      const iframe = this.$refs.grapejsRef.querySelectorAll("iframe")[0]
        .contentWindow;
      console.log("iframe:", iframe);
      iframe?.postMessage({ cmd, data }, "*"); // "http://localhost:8080");
    },
  },
};
</script>
